var tokenKey = '_approw_token';
var userKey = '_approw_user';
var AuthenticationTokenProvider = /** @class */ (function () {
    function AuthenticationTokenProvider(options) {
        this.options = options;
        // In order to be compatible with the situation where the server does not support localStorage
        this.token = null;
        this.user = null;
    }
    AuthenticationTokenProvider.prototype.setToken = function (token) {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(tokenKey, token);
        }
        else {
            this.token = token;
        }
    };
    AuthenticationTokenProvider.prototype.getToken = function () {
        return typeof localStorage !== 'undefined'
            ? localStorage.getItem(tokenKey) || ''
            : this.token;
    };
    AuthenticationTokenProvider.prototype.getUser = function () {
        return typeof localStorage !== 'undefined'
            ? localStorage.getItem(userKey)
                ? JSON.parse(localStorage.getItem(userKey))
                : null
            : this.user;
    };
    AuthenticationTokenProvider.prototype.setUser = function (user) {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(userKey, JSON.stringify(user));
            localStorage.setItem(tokenKey, user.token);
        }
        else {
            this.user = user;
            this.token = user.token;
        }
    };
    AuthenticationTokenProvider.prototype.clearUser = function () {
        if (typeof localStorage !== 'undefined') {
            localStorage.removeItem(userKey);
            localStorage.removeItem(tokenKey);
        }
        else {
            this.user = null;
            this.token = null;
        }
    };
    return AuthenticationTokenProvider;
}());
export { AuthenticationTokenProvider };
//# sourceMappingURL=data:application/json;base64,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